import e from "../../atom/stationMode.mjs";
import { useRecoilState as s } from "recoil";
const a = () => {
  const [t, o] = s(e);
  return { stationMode: t, setStationMode: o };
}, r = a;
export {
  r as default
};
